export default __webpack_public_path__ + "static/media/SIP_AGC_LOGO_2023.d0215456.png";